import { EmploymentForm, WorkFormat } from '@hh.ru/types-hh-microcore';

import { useSelector } from 'src/hooks/useSelector';
import { EMPTY_CLUSTER } from 'src/models/search/common/clusters';
import { UserType } from 'src/models/userType';
import { ClusterKey } from 'src/types/search/common/clusters';
import { ScheduleCamelCase } from 'src/utils/constants/schedule';

const NOT_FULL_RESULT = 50;
const EMPTY_ARRAY = [] as const;

type UseShowNeighboursAreaBanner = () => boolean;

const useShowNeighboursAreaBanner: UseShowNeighboursAreaBanner = () => {
    const isEmployer = useSelector((state) => state.userType === UserType.Employer);
    const totalResults = useSelector((state) => state.vacancySearchResult.totalResults);
    const clusterNeighbours = useSelector((state) => state.searchClusters?.[ClusterKey.Neighbours]) || EMPTY_CLUSTER;
    const activeSchedules =
        useSelector((state) => state.searchClusters?.[ClusterKey.Schedule]?.selectedValues) || EMPTY_ARRAY;
    const activeWorkFormat =
        useSelector((state) => state.searchClusters?.[ClusterKey.WorkFormat]?.selectedValues) || EMPTY_ARRAY;
    const activeEmploymentForm =
        useSelector((state) => state.searchClusters?.[ClusterKey.EmploymentForm]?.selectedValues) || EMPTY_ARRAY;
    const isExpNewEmploymentFilters = useSelector((state) => state.isExpNewEmploymentFilters);

    const isRemoteOrFlyInFlyOutActive = isExpNewEmploymentFilters
        ? activeWorkFormat.includes(WorkFormat.Remote) || activeEmploymentForm.includes(EmploymentForm.FlyInFlyOut)
        : activeSchedules.includes(ScheduleCamelCase.FlyInFlyOut) || activeSchedules.includes(ScheduleCamelCase.Remote);

    return (
        !isRemoteOrFlyInFlyOutActive &&
        !isEmployer &&
        totalResults <= NOT_FULL_RESULT &&
        Object.keys(clusterNeighbours.groups).length > 0
    );
};

export { useShowNeighboursAreaBanner };
